import React, { useEffect } from 'react'
import ScrollToTopButton from './ScrollToTopButton';
import { NavLink } from 'react-router-dom';

const Blog = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className='blog-mainsection'>
                <ScrollToTopButton />
                <div className='container-fluid'>
                    <div className='aboutus-bgsection'>
                        <div className='container'>
                            <h2 className='aboutus-header'>Latest Blog</h2>
                            <div>
                                <h3 className='pages-head'> <NavLink to={'/'} aria-label="Read more about the latest blog updates" className="about-s">HOME</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />Our Blog</h3>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='bolg-section2'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-4'>
                                <div style={{ textDecoration: 'none' }} to={'/BlogPage'} aria-label="Read more about the latest blog updates on our site" >
                                    <div className='blogsection-box'>
                                        <div style={{ position: 'relative' }}>
                                            <img className='blog-im' src='../assets/images/blog3.jpg' alt='blog' />
                                            <div className='blog-datesec'>
                                                <img src='../assets/images/cal.png' alt='cal' />
                                                <p>15 Mar, 2025</p>
                                            </div>
                                        </div>
                                        <div className='blogtext-sec'>
                                            <h3 className='blogtextsec-head'>Challenges of a new technology business in Year 2025</h3>
                                            <p className='blogtextsec-txt'>We are committed to offering the best technology services to meet your unique needs. ...</p>
                                            <NavLink style={{textDecoration: 'none'}} to={'/BlogPage'} aria-label="Read more about the latest blog updates on our site" >
                                                <button className='blogtextsec-bt'>Read More</button>
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                               
                                    <div className='blogsection-box'>
                                        <div style={{ position: 'relative' }}>
                                            <img className='blog-im' src='../assets/images/blog2.webp' alt='blog' />
                                            <div className='blog-datesec'>
                                                <img src='../assets/images/cal.png' alt='cal' />
                                                <p>15 Mar, 2025</p>
                                            </div>
                                        </div>
                                        <div className='blogtext-sec'>
                                            <h3 className='blogtextsec-head'>New plugins for creating new charts in dashboard</h3>
                                            <p className='blogtextsec-txt'>4Sight Tech offers a full range of consultancy & training methods for data analysis, including data collection, statistical ...</p>
                                            <button className='blogtextsec-bt'>Read More</button>
                                        </div>
                                    </div>
                               
                            </div>
                            <div className='col-md-4'>
                               
                                    <div className='blogsection-box'>
                                        <div style={{ position: 'relative' }}>
                                            <img className='blog-im' src='../assets/images/blog4.jpg' alt='blog' />
                                            <div className='blog-datesec'>
                                                <img src='../assets/images/cal.png' alt='cal' />
                                                <p>15 Mar, 2025</p>
                                            </div>
                                        </div>
                                        <div className='blogtext-sec'>
                                            <h3 className='blogtextsec-head'>The future of headset among Youngsters</h3>
                                            <p className='blogtextsec-txt'>4Sight Tech offers a full range of consultancy & training methods for data analysis, including data collection, statistical ...</p>
                                            <button className='blogtextsec-bt'>Read More</button>
                                        </div>
                                    </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Blog;